export default __webpack_public_path__ + "static/media/fireFN20.8e807148.svg";